import { FontConfig } from "../types"

export const BODY_CAPTION_CONFIG: FontConfig = {
  title: "BODY/caption",
  mobile: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Regular", tw: "font-normal" },
    size: { px: 10, tw: "text-[10px]" },
    lineHeight: { px: 13, tw: "leading-[14px]" },
  },
  tablet: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Regular", tw: "font-normal" },
    size: { px: 11, tw: "text-[11px]" },
    lineHeight: { px: 14, tw: "leading-[14px]" },
  },
  desktop: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Regular", tw: "font-normal" },
    size: { px: 12, tw: "text-[12px]" },
    lineHeight: { px: 15, tw: "leading-[15px]" },
  },
}
